



















































































































































































































import Vue from "vue";
// import HeaderComponent from "@/components/HeaderComponent.vue";
import ApiService from "@/services/ApiService";
import ActionsHistory from "@/components/admin/ActionsHistory.vue";
export default Vue.extend({
  name: "SingleParentModal",
  props: {
    userId: Number,
  },
  components: {
    ActionsHistory,
  },
  data() {
    return {
      user: {},
      activeTab: "user",
    };
  },
  methods: {
    handleClick(tab, event) {
      // if (tab.name === "history") {
      // }
    },
    action(type, id, userRoleId = null) {
      if (type === "new_term") {
        ApiService.sadminApi.newTerm({ user_id: this.user.id }).then(() => {
          this.$message({
            showClose: true,
            message: "User has new term!",
            type: "success",
          });
        });
      } else if (type === "reset_password") {
        ApiService.sadminApi
          .resetPassword({ user_id: this.user.id })
          .then(() => {
            this.$message({
              showClose: true,
              message: "Password has been reset!",
              type: "success",
            });
          });
      } else if (type === "delete_user") {
        ApiService.sadminApi
          .deleteAction({ user_id: this.user.id, delete_students: true })
          .then(() => {
            this.$message({
              showClose: true,
              message: "Deleted!",
              type: "success",
            });
            this.$emit("close");
          });
        // this.user = {};
      } else if (type === "delete_student") {
        ApiService.sadminApi.deleteAction({ student_id: id }).then(() => {
          this.$message({
            showClose: true,
            message: "Deleted!",
            type: "success",
          });
          this.loadUser();
        });
        this.user = {};
      } else if (type === "delete_user_journey") {
        ApiService.sadminApi
          .deleteAction({ type: "delete_user_journey", id: id })
          .then(() => {
            // ApiService.sadminApi.newTerm({ user_id: this.user.id }).then(() => {
            this.$message({
              showClose: true,
              message: "Deleted!",
              type: "success",
            });
            // });
            this.loadUser();
          });
      } else if (type === "delete_user_device") {
        ApiService.sadminApi
          .deleteAction({ type: "delete_user_device", id: id })
          .then(() => {
            this.$message({
              showClose: true,
              message: "Deleted!",
              type: "success",
            });
            this.loadUser();
          });
      } else if (type === "delete_user_school") {
        ApiService.sadminApi
          .deleteAction({ type: "delete_user_school", id: id })
          .then(() => {
            this.$message({
              showClose: true,
              message: "Deleted!",
              type: "success",
            });
            this.loadUser();
          });
      } else if (type == "remove_user") {
        ApiService.sadminApi
          .removeUserFromSchool({ user_id: id })
          .then(() => {
            this.$message({
              showClose: true,
              message: "Removed!",
              type: "success",
            });
            this.loadUser();
          });
      }
      // ApiService.generalApi.user_action(type, id).then(resp => {});
      // TODO add action url
    },
    loadUser() {
      ApiService.generalApi
        .getParentOrStudent({ user_id: this.userId })
        .then((resp) => {
          if (resp.data.user) {
            this.user = resp.data.user;
          }
        });
    },
  },
  computed: {
    accType: function () {
      return this.$store.state.accType;
    },
  },
  mounted() {
    this.loadUser();
    // this.$store.dispatch("logout", true);
  },
});
